import { Routes, Route } from "react-router-dom";
import { OSCI0402001Q } from "../rcpt/OSCI0402001Q";
import { OSCI0402002Q } from "../rcpt/OSCI0402002Q";
import { OSCI0402003Q } from "../rcpt/OSCI0402003Q";
import { OSCI0402004Q } from "../rcpt/OSCI0402004Q";
import { OSCI0402005Q } from "../rcpt/OSCI0402005Q";
import { OSCI0402006Q } from "../rcpt/OSCI0402006Q";
import { OSCI0402007S } from "../rcpt/OSCI0402007S";
import { OSCI0402008Q } from "../rcpt/OSCI0402008Q";
/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const RcptRouter = () => {
    return (
        <Routes>
            <Route path="/osci0402001q" element={<OSCI0402001Q />} />
            <Route path="/osci0402002q" element={<OSCI0402002Q />} />
            <Route path="/osci0402002q/:bllMgmtId/:scrnTp/:scrnId" element={<OSCI0402002Q />} />
            <Route path="/osci0402003q" element={<OSCI0402003Q />} />
            <Route path="/osci0402004q" element={<OSCI0402004Q />} />
            <Route path="/osci0402005q" element={<OSCI0402005Q />} />
            <Route path="/osci0402006q" element={<OSCI0402006Q />} />
            <Route path="/osci0402006q/:bllMgmtId" element={<OSCI0402006Q />} />
            <Route path="/osci0402006q/:bllMgmtId/:aprvYn" element={<OSCI0402006Q />} />
            <Route path="/osci0402007s/:mode" element={<OSCI0402007S />} />
            <Route path="/osci0402007s/:mode/:bllMgmtId/:scrnTp" element={<OSCI0402007S />} />
            <Route path="/osci0402008q" element={<OSCI0402008Q />} />
        </Routes>
    );
};
